// Locale strings of report 2.2 (driver-statement), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "Driver Statement (per trip)",
  title: "Driver Statement (per trip)",
  captain: "Driver",
  captainHint: "Search by name, phone or driver id",
  captainId: "Driver id",
  captainIdHint: "Enter the driver id",
  captainSearchForbidden: "You may not search drivers - enter the driver id directly",
  captainSearchFailed: "Driver search failed - enter the driver id directly",
  captainNoResults: "No matching driver",
  chooseCaptainFirst: "Choose a driver, then press Apply",
  driverInfo: "Driver details",
  name: "Name",
  phone: "Phone",
  driverAccount: "Driver account",
  carModel: "Car model",
  plate: "Plate",
  owner: "Car owner",
  ownerAccount: "Owner account",
  walletBalance: "In-app wallet balance",
  walletNote: "Operational balance, separate from the ledger",
  openingBalance: "Opening balance",
  closingBalance: "Closing balance",
  noCar: "No car on file",
  noLeaf: "No sub-account",
  tripsTitle: "Trips",
  otherTitle: "Other movements",
  balancesTitle: "Driver accounts in the general ledger",
  reconciliationTitle: "Reconciliation with the general ledger",
  notesTitle: "Notes",
  col: {
    trip: "Trip",
    date: "Date",
    type: "Type",
    paymentMethod: "Payment method",
    tripTotal: "Trip total",
    driverAccount: "Driver account",
    ownerAccount: "Owner account",
    companyShare: "Company share",
    ownerShare: "Owner share",
    driverShare: "Driver share",
    bonus: "Bonus",
    fine: "Fine",
    netDriverShare: "Net driver share",
    cashReceived: "Cash received",
    dueDriver: "Due from company (driver)",
    dueOwner: "Due from company (owner)",
    dueToCompany: "Due to company from driver (cash)",
    reference: "Entry no.",
    description: "Description",
    account: "Account",
    debit: "Debit",
    credit: "Credit",
    remark: "Remark",
    role: "Kind",
    opening: "Opening",
    closing: "Closing",
    side: "Balance side",
  },
  detail: {
    bookingDate: "Trip date",
    settledAt: "Settled at",
    companyCommission: "Company commission",
    companyKept: "Company part of the remainder",
    discount: "Discount",
    toPay: "Paid by rider",
    cashCollected: "Cash collected from rider",
    percentages: "Split (company / driver / owner)",
    journalEntry: "Ride entry",
    journalDate: "Entry date",
    glEffect: "Entry effect on the driver account",
    expectedEffect: "Expected effect (driver share - cash)",
    noEntry: "No ride entry",
    typeSource: "Type source",
  },
  typeSource: {
    entry: "From the ride entry rule",
    owner_row: "From the owner-share row",
    percentages: "From the split",
    car: "From the current car",
  },
  role: {
    leaf: "Driver sub-account",
    clearing: "Drivers clearing (legacy lines with the driver id)",
  },
  rec: {
    opening: "Opening balance",
    rideDebit: "Ride entries - debit",
    rideCredit: "Ride entries - credit",
    otherDebit: "Other movements - debit",
    otherCredit: "Other movements - credit",
    computedClosing: "Computed closing (opening + credit - debit)",
    closing: "Closing balance in the ledger",
    difference: "Difference",
    reconciled: "Reconciled",
    notReconciled: "Not reconciled",
    tripsEffect: "Trips effect on the driver balance (owed to the company is negative)",
  },
  flag: {
    notPosted: "Not posted to the ledger (outside the totals)",
    inTrip: "Shown in trip row",
    reversal: "Reversal",
    reversed: "Reversed",
    mismatch: "Entry effect does not match the split",
  },
  sheetDriver: "Driver",
  sheetTrips: "Trips",
  sheetOther: "Other movements",
  sheetBalances: "Balances",
  field: "Item",
  value: "Value",
  tripsCount: "Trips",
  details: "Details",
};
